'use strict';

angular.module('DoohApps').factory('AppAdmin', ['restApi', function (restApi) {
    var controllerName = 'AppAdmin/';

    return {
        checkAppVerBeforeDelete: function (successCallback, appId) {
            restApi.GetApiMethod(successCallback, controllerName + 'CheckAppVerBeforeDelete?appVerId=' + appId);
        },
        deleteAppVersion: function (successCallback, versionId) {
            restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteAppVersion?versionId=' + versionId);
        },
        getApps: function (successCallback, objectFilterOptions) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetAppList', objectFilterOptions);
        },
        checkAppBeforeDelete: function (successCallback, appId) {
            restApi.GetApiMethod(successCallback, controllerName + 'CheckAppBeforeDelete?appId=' + appId);
        },
        getLicensesForAppAdmin: function (successCallback, objectFilterOptions) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetLicensesForAppAdmin', objectFilterOptions);
        },
        getAppVersionListByAppId: function (successCallback, appId) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetAppVersionListByAppId?appId=' + appId);
        },
        getAppByIdAdmin: function (successCallback, id, verId) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetAppById?appId=' + id + '&appVerId=' + verId);
        },
        updateApp: function (successCallback, app) {
            restApi.PutApiMethod(successCallback, controllerName + 'PutAppStore', app);
        },
        addApp: function (successCallback, app) {
            restApi.PostApiMethod(successCallback, controllerName + 'PostAppStore', app);
        },
        deleteApp: function (successCallback, id) {
            restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteAppStore?appId=' + id);
        },
        GetVersionFiles: function (successCallback, appId) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetVersionFiles?AppVersionID=' + appId);
        },
        validateNewAppFiles: function (successCallback, newFiles) {
            restApi.PostApiMethod(successCallback, controllerName + 'ValidateNewAppFiles', newFiles);
        },
        AddNewVersionFile: function (successCallback, appVersion) {
            restApi.PostApiMethod(successCallback, controllerName + 'PostVersionFile', appVersion);
        },
        UpdateVersionFile: function (successCallback, versionFile) {
            restApi.PutApiMethod(successCallback, controllerName + 'PutVersionFile', versionFile);
        },
        CheckAppVersionFile: function (successCallback, fileID) {
            restApi.GetApiMethod(successCallback, controllerName + 'CheckAppVersionFile?fileID=' + fileID);
        },
        DeleteVersionFile: function (successCallback, id, version) {
            restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteVersionFile?Id=' + id + '&versionID=' + version);
        },
        GetExistingVersionFiles: function (successCallback, ExistingVersionFiles) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetExistingVersionFiles', ExistingVersionFiles);
        },
        AddExistingVersionFiles: function (successCallback, data) {
            restApi.PostApiMethod(successCallback, controllerName + 'PostExistingVersionFiles', data);
        },
        getExecutableActions: function (successCallback, appId) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetExecutableActions?AppVersionID=' + appId);
        },
        AddExecutableAction: function (successCallback, VerExeAction) {
            restApi.PostApiMethod(successCallback, controllerName + 'PostExecutableAction', VerExeAction);
        },
        updateExecutableAction: function (successCallback, ExecutableAction) {
            restApi.PutApiMethod(successCallback, controllerName + 'PutExecutableAction', ExecutableAction);
        },
        deleteExecutableAction: function (successCallback, id) {
            restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteExecutableAction?Id=' + id);
        },
        getRequirementTypes: function (successCallback) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetRequirementTypes');
        },
        addRemoveAppRequirements: function (successCallback, appRequirements) {
            restApi.PostApiMethod(successCallback, controllerName + 'AddRemoveHardwareRequirements', appRequirements);
        },
        updateAppImages: function (successCallback, appData) {
            restApi.PostApiMethod(successCallback, controllerName + 'UpdateAppImages', appData);
        },
        updateAppVersion: function (successCallback, appVersion) {
            restApi.PutApiMethod(successCallback, controllerName + 'PutAppVersion', appVersion);
        },
        addAppVersion: function (successCallback, appVersion) {
            restApi.PostApiMethod(successCallback, controllerName + 'PostAppVersion', appVersion);
        },
        ExportSettings: function (successCallback, exportOptions) {
            restApi.GetApiMethod(successCallback, controllerName + 'ExportSettings', exportOptions);
        },
        ImportSettings: function (successCallback, importOptions) {
            restApi.PostApiMethod(successCallback, controllerName + 'ImportSettings', importOptions);
        },
        resolveImportConflict: function (successCallback, importResolve) {
            restApi.PostApiMethod(successCallback, controllerName + 'ImportResolve', importResolve);
        },
        copyApplication: function (successCallback, appData) {
            restApi.PostApiMethod(successCallback, controllerName + 'CopyApplication', appData);
        },
        getAllApps: function (successCallback) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetAllApps');
        },
        saveConfiguratorBlocks: function (successCallback, blocks) {
            restApi.PostApiMethod(successCallback, controllerName + 'SaveConfiguratorBlocks', blocks);
        },
        getCustomCode: function (successCallback, AppversionID) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetCustomCode?AppversionID=' + AppversionID);
        },
        saveCustomCode: function (successCallback, data) {
            restApi.PostApiMethod(successCallback, controllerName + 'SaveCustomCode', data);
        },
        copyVersion: function (successCallback, appData) {
            restApi.PostApiMethod(successCallback, controllerName + 'CopyVersion', appData);
        },
        moveAssets: function (successCallback, data) {
            restApi.PostApiMethod(successCallback, controllerName + 'MoveAssets', data);
        },
        getFileUrl: function (successCallback, fileID) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetFileUrl?fileID=' + fileID);
        },
    }
}])
